import type { ChatLayoutViewProps } from './ChatLayoutView.types';
import { PinnedMessageView } from 'Components/Chat/ChatLayout/PinnedMessageView';
import { ChatLayoutContext } from 'Components/Chat/contexts/ChatLayoutContext';
import { SharedFilesAndLinksView } from 'Modules/sharedItems';
import React from 'react';

export const ChatLayoutView: React.FC<ChatLayoutViewProps> = ({ children }) => {
  const { view } = React.useContext(ChatLayoutContext);

  if (view === 'pinned-messages') {
    return <PinnedMessageView />;
  }

  if (view === 'shared-files-and-links') {
    return <SharedFilesAndLinksView />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};
